import React from 'react'
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames'

class Video extends React.PureComponent {

  video = null

  componentDidMount(){
    const { onRef } = this.props
    if (onRef) {
      onRef(this)
    }
  }

  componentWillUnmount(){
    const { onRef } = this.props
    if (onRef) {
      onRef(null)
    }
  }

  play(){
    if (this.video) {
      setTimeout(() => {
        this.video.play()
      }, 50)
    }
  }

  pause(){
    if (this.video) {
      this.video.pause()
    }
  }

  reset(){
    if (this.video) {
      this.video.play()
    }
  }

  render(){
    const { src, classes, className, autoPlay, onRef } = this.props
    return <video className={ classNames(classes.video, className) } autoPlay={!!autoPlay} ref={ el => this.video = el} muted >
      <source src={ src } type="video/mp4" />
    </video>
  }
}

const style = {
  video: {
    width: '100%'
  }
}

export default withStyles(style)(Video)
